const processEnv = {
    NODE_ENV: process.env.NODE_ENV,
    KEYCLOAK_URL: process.env.KEYCLOAK_URL,
    LOG_LEVEL: process.env.LOG_LEVEL,
    CLIENT_ID: process.env.CLIENT_ID,
    IAM_URL: process.env.IAM_URL,
    IAM_UI_URL: process.env.IAM_UI_URL,
    WS_URL: process.env.WS_URL,
    CONFIG_API_URL: process.env.CONFIG_API_URL,
    SUBDOMAIN: process.env.SUBDOMAIN,
    ENV_NAME: process.env.ENV_NAME,
};

const deployEnv = window && window.deployEnv ? window.deployEnv : {};
const env = {
    ...processEnv,
    ...deployEnv,
};

export { env };

export const isLocalEnv = () => {
    const isLocal = ['test', 'local'].indexOf(env.NODE_ENV) !== -1;
    if (isLocal) {
        window.console.warn('Using Local/Test env');
    }
    return isLocal;
};
